import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../Vas';
import '../../css/Customers.css';
//import CreateCustomers from './CreateCustomers';
import { PagingTable,Loading,SelectField } from 'component-lib';
import { DateTimeHelper }  from 'utils-lib';
import {CustomerModel,RequestAjaxClass} from 'models-lib';
var moment = require('moment');
        moment().format();
class Customers extends Component{

    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.Limit = 10;
        this.state.Start = 0;
        this.state.InfoText = '';

        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.CustomerModel = new CustomerModel([this],null,this.Request);
        
        this.CustomersConfig = Vas.Config.Customers;
        this.IconConfig = Vas.Config.ShowIconsOrButtons;

        this.customerAboveInput = React.createRef();
    }

    componentWillMount(){
        ReactDOM.render(<Loading modal={true} />,document.getElementById('messageContainer'));
        this.Request.setAuth(true);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setErrorHandler(()=>{
            ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
        })

        this.Request2.setAuth(true);
        this.Request2.setApiKey(Vas.ApiKey);
        this.Request2.setApiUrl(Vas.ApiUrl);
        this.Request2.setErrorHandler(()=>{
            ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
        });

        this.LogoClick();

        this.FontSizeClick();
    }

    componentDidMount(){
      this.getCustomerAbove();

      this.LogoClick();

      this.FontSizeClick();
    }
    Update(observer){
        let me = this;
        this.setState({},()=>{
          if(observer === "CustomersWithCustomersAbove"){
            let customers = [];
            if (me.CustomerModel.Customers)
            {

                me.CustomerModel.Customers.forEach(function(value) {
                    let customer = {};
                    customer.Id = value.Customer.Id;
                    customer.Name1 = value.Customer.Name1;
                    customer.Name2 = value.Customer.Name2;
                    customer.Name3 = value.Customer.Name3;
                    customer.Gender = value.Customer.Gender;
                    customer.HouseNumber = value.Customer.HouseNumber;
                    customer.DateOfBirth = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(value.Customer.DateOfBirth,true,localStorage.getItem('vas_language')));
                    customer.Street = value.Customer.Street;
                    customer.Vid = value.Customer.Vid;
                    customer.PostCode = value.Customer.PostCode;
                    customer.City = value.Customer.City;
                    customer.CustomerNumber = value.Customer.CustomerNumber;
                    customer.ClientId = value.Customer.ClientId;
                    customer.Vu = value.Customer.Vu;
                    customer.Email = value.Customer.Email;
                    customer.CustomerAbove = value.CustomerAbove[0].Name;
                    customers.push(customer);
                });
              }
            if (me.refs.table){
                me.refs.table.setState({ Data: customers, Count: this.CustomerModel.Count, Limit: this.CustomerModel.Limit, Start: this.CustomerModel.Start, End: this.CustomerModel.Start+customers.length });
            }
//            ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
          }else if(observer === "CustomersAbove"){
            if(this.CustomerModel.CustomersAbove.length > 0){
                let data= [];
                for(let i = 0; i<this.CustomerModel.CustomersAbove.length; i++){
                    let d = {Key: this.CustomerModel.CustomersAbove[i].Id , 
                            Display : this.CustomerModel.CustomersAbove[i].Name};
                    data.push(d);
                }

                this.customerAboveInput.current.setState({ Data : data});
                ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
            }
        }
          
        });

        this.LogoClick();

        this.FontSizeClick();
    }

    getCustomerAbove(){
      this.CustomerModel.GetCustomersAboveByCustomerId(localStorage.getItem("vas_customerId"),moment().format("YYYY-MM-DD T 00:00:00"),true);
  }
    load(sendData, trigger = 'blubb'){
      if(this.state.CustomerAbove){

        if(trigger == "Firma"){

          var sendDataArray = sendData.split('&');
          var sendDataString = sendDataArray[0] + '&start=0&' + sendDataArray[2];

          localStorage.setItem("CustomerAboveId", this.state.CustomerAbove);

          this.CustomerModel.GetCustomersWithCustomerAbove(sendDataString,null,null,null,null,null,null,null,null,null,null,null,null,null,this.state.CustomerAbove);
        } else{
          this.CustomerModel.GetCustomersWithCustomerAbove(sendData,null,null,null,null,null,null,null,null,null,null,null,null,null,this.state.CustomerAbove);
        }
      }
          
    }

    createCustomers(){
      Vas.GetView("CreateCustomer",null,true);
    }

    loadCustomer(id){
        localStorage.setItem('employee_id',id);
        for(let i = 0; i< this.CustomerModel.Customers.length; i++){
          if(this.CustomerModel.Customers[i].Id === id){
            localStorage.setItem('employee_name1',this.CustomerModel.Customers[i].Name1);
            localStorage.setItem('employee_name2',this.CustomerModel.Customers[i].Name2);
          }
        }
        
        Vas.GetView("CustomerCard",{ Id:id },true);
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');
      let role = localStorage.getItem("vas_role");
  
      if(kontrastNumber == "true"){

        $(".loader").attr('style', 'border-top: 16px solid #1d5c87; border-bottom: 16px solid #1d5c87;');
        $('html body div#messageContainer div.modalLoading.show-modalLoading div.loader').attr('style', 'border-top: 16px solid #1d5c87; border-bottom: 16px solid #1d5c87;');

          if (role === '3'){
            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#0.tableHeaderHeader').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');
            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');
            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');
            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');
            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#4.tableHeaderHeader').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');
            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#5.tableHeaderHeader').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');
            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#6.tableHeaderHeader').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');

            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').addClass('paddingLeft20');

            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#0.tableHeaderHeader table thead tr th.tableHeader').attr('style', 'padding-right: 0px; color: #1d5c87;');
            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').attr('style', 'padding-right: 0px; color: #1d5c87;');
            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').attr('style', 'padding-right: 0px; color: #1d5c87;');
            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader table thead tr th.tableHeader').attr('style', 'padding-right: 0px; color: #1d5c87;');
            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#4.tableHeaderHeader table thead tr th.tableHeader').attr('style', 'padding-right: 0px; color: #1d5c87;');
            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#5.tableHeaderHeader table thead tr th.tableHeader').attr('style', 'padding-right: 0px; color: #1d5c87;');
            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#6.tableHeaderHeader table thead tr th.tableHeader').attr('style', 'padding-right: 0px; color: #1d5c87;');

            $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenue div div div#MenuItems.Menu-items div#MenuItem_Download_CSV').attr('style', 'background-color: #1d5c87;');
          }    



      }
  }

    FontSizeClick(){
      var schriftgröße = localStorage.getItem('Schriftgröße');
      let role = localStorage.getItem("vas_role");

      //Schriftgröße bei Klick in 2er Schritten erhöhen

        if(schriftgröße != null){

              switch(schriftgröße){
                case "0":

                      if (role === '3'){
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft20').addClass('paddingLeft20');
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#4.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft20').addClass('paddingLeft20');
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#6.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft20').addClass('paddingLeft20');

                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenue div div div#MenuItems.Menu-items div#MenuItem_Download_CSV').removeClass('Schriftgröße_18 downloadCsvPadding_1102').addClass('Schriftgröße_19 downloadCsvPadding_1102');
                      }
                break;
                case "1":

                      if (role === '3'){
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft20').addClass('paddingLeft0');
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#4.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft20').addClass('paddingLeft0');
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#4.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft20').addClass('paddingLeft0');

                        $('div div div.form.customerForm div table tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Download_CSV').removeClass('Schriftgröße_19 downloadCsvPadding1102').addClass('Schriftgröße_14');
                      }

                break;
                case "2":

                      if (role === '3'){
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft0').addClass('paddingLeft0');
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#4.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft0').addClass('paddingLeft0');
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#6.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft0').addClass('paddingLeft0');

                        $('div div div.form.customerForm div table tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Download_CSV').removeClass('Schriftgröße_14').addClass('Schriftgröße_15 downloadCsvPadding1106');
                      }

                break;
                case "3":
                      if (role === '3'){
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft0').addClass('paddingLeft0');
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#4.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft0').addClass('paddingLeft0');
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#6.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft0').addClass('paddingLeft0');

                        $('div div div.form.customerForm div table tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Download_CSV').removeClass('Schriftgröße_15 downloadCsvPadding1106').addClass('Schriftgröße_16 downloadCsvPadding1106');
                      }
                break;
                case "4":

                      if (role === '3'){
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft0').addClass('paddingLeft0');
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#4.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft0').addClass('paddingLeft0');
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#6.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft0').addClass('paddingLeft0');

                        $('div div div.form.customerForm div table tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Download_CSV').removeClass('Schriftgröße_16 downloadCsvPadding1106').addClass('Schriftgröße_17 downloadCsvPadding1104');
                      }
                break;
                case "5":                

                      if (role === '3'){
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft0').addClass('paddingLeft20');
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#4.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft0').addClass('paddingLeft20');
                        $('div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#6.tableHeaderHeader table thead tr th.tableHeader').removeClass('paddingLeft0').addClass('paddingLeft20');

                        $('div div div.form.customerForm div table tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Download_CSV').removeClass('Schriftgröße_17 downloadCsvPadding1104').addClass('Schriftgröße_18 downloadCsvPadding1102');
                        
                      }
                break;
              }
        }
  }


    render(){
        let role = localStorage.getItem("vas_role");
        let columns =[];
        if (role === '3' ){
            columns = [Vas.Resources.Labels["EmployeeNumber"],Vas.Resources.Labels["FirstName"],Vas.Resources.Labels["Name"], Vas.Resources.Labels["DateOfBirth"],
            Vas.Resources.Labels["City"],Vas.Resources.Labels["Zip"], Vas.Resources.Labels["Company"]];
        } 

        let add = false;
        if(this.CustomersConfig.AllowToAddCustomers === true){
          add = true;
        }

        return (
          <div
            className={"form customerForm"}
            style={{ width: '1000px' }}>
            <div >
              <table>
                <thead>
                  <tr>
                    <th>
                      {this.state.InfoText}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                    <SelectField
                AppURL={this.ApplicationUrl} 
                me={this} 
                ref={this.customerAboveInput} 
                Id={"CustomerAbove"} 
                IsRequired={true} 
                Label={Vas.Resources.Labels["Company"]} 
                Tooltip={Vas.Resources.Tooltips["Company"]} 
                OnChange={()=>{ this.setState({ CustomerAbove: $("#CustomerAbove").val() },()=>{this.load(this.refs.table.PrepareSendData(), 'Firma');});}} />
                    </td>
                  </tr>
                  <tr>
                    <td><PagingTable
                      ref="table"
                      SearchCol={"Name1"}
                      TableReference={this}
                      DataBaseTable={"B2Kunde"} 
                      Border={false}
                      Search={true}
                      Selectable={false}
                      Limit={this.state.Limit}
                      Start={this.state.Start}
                      End={this.state.End}
                      Count={this.state.Count} 
                      ParamCustomerCategory={"Abo"}
                      Columns={columns}
                      SortColumns={columns}
                      Keys={["CustomerNumber","Name2","Name1","DateOfBirth","City","PostCode","CustomerAbove"]} 
                      Data={this.state.Data}
                      CSVTableName={Vas.Resources.Labels["Customers"]}
                      CSV={true}
                      CSVController={"Customers"}
                      ApiURL={Vas.ApiUrl} 
                      ApiKey={Vas.ApiKey}
                      Token={localStorage.getItem('vas_token')}
                      AppURL={Vas.ApplicationUrl}
                      LabelPage={Vas.Resources.Labels["Page"]}
                      LabelOf={Vas.Resources.Labels["Of"]}
                      LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                      Width={'100%'}
                      CWidth={[120,120,120,120,120,100]} 
                      Add={add}
                      AddClick={()=>{this.createCustomers();}}
                      RowOnClick={(id)=>{this.loadCustomer(id);}}
                      NewApi={true}
                      ShowIcons={this.IconConfig.ShowIcons}
                /></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            
          </div> 
        );
    }
}
export default Customers;
